import type { ThemeOptions } from '@mui/material/styles';

// The `sm` breakpoint, spelled out. Typography options are read before the theme exists, so
// `theme.breakpoints` is not available here and the query has to be written by hand.
const phone = '@media (max-width:599.95px)';

export const typography: ThemeOptions['typography'] = {
  fontFamily: '"Roboto", "Segoe UI", sans-serif',
  // Page titles shrink on a phone. At 2.125rem a heading like "Каталог игр" sits beside an
  // action button on a 360px screen and pushes it off the row; the same words at 1.75rem fit
  // and still read as the title of the page.
  h4: { fontWeight: 600, [phone]: { fontSize: '1.75rem' } },
  h5: { fontWeight: 600, [phone]: { fontSize: '1.35rem' } },
  h6: { fontWeight: 600 },
  button: { fontWeight: 500 },
};
